import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
} from "reactstrap";
import { useVisible } from "../../../../../utils/hooks/useVisible";
import { useIsMasterCompany } from "../../../../../utils/hooks/company";

function BulkActions({ rows, rowSelection, batchRemove }) {
	const { t } = useTranslation();
	const { visible, toggle } = useVisible();
	const isMasterCompany = useIsMasterCompany();

	const ids = useMemo(() => {
		return Object.keys(rowSelection);
	}, [rowSelection]);

	const deleteDisabled = useMemo(() => {
		const hasSystemRoles = ids.some((id) => {
			const row = rows.find((row) => row.id === id);
			return row?.isSystem;
		});
		return ids.length === 0 || !batchRemove || !isMasterCompany || hasSystemRoles;
	}, [rows, ids, batchRemove, isMasterCompany]);

	const remove = useCallback(() => {
		batchRemove?.(ids);
	}, [batchRemove, ids]);

	return (
		<Dropdown isOpen={visible} toggle={toggle}>
			<span className="text-sm font-weight-600 text-dark mr-1 text-center">
				{t("selected")}{" "}
				<span
					className="text-sm rounded-circle py-1 px-2 mx-1"
					style={{ backgroundColor: "#ced4da" }}
				>
					{Object.keys(rows).length}
				</span>
			</span>

			<DropdownToggle
				className="btn-round btn-icon shadow-none border"
				size="sm"
			>
				{t("actions")}
			</DropdownToggle>

			<DropdownMenu>
				<DropdownItem onClick={remove} disabled={deleteDisabled}>
					{t("delete")}
				</DropdownItem>
			</DropdownMenu>
		</Dropdown>
	);
}

export default BulkActions;
